module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAARVBMVEVHcEz/ggD/gwH/gwD/ggH/fAD/ewD/hAD/gwD/ggH/gwD/ggD/ggD/ggD/gAD/gwH/gwD/gwD/gwH/gwH/gQD/gwH/gwGijPN8AAAAF3RSTlMAfr5ztQwFD1nBjxhjLSLjO1DLrUP0pJuojUIAAADKSURBVCjPlZHJksMgDERBAgFi3/z/nzr2xHaqEnxIn6h6Qmq1hJNarNXYPJDnP/AjIVoTiramm9BRdirJrMJNkrXxZMa6CTehCg1f/n3ljUO8iMc8e9mflALL4jWdhMZex1yTjshY9O2aIsqRhmREZjzn/RMf2JqDu9zQ0zsdXTmko2fZci+Xe0CTrJSvDnrI6q+tFEZsdyHp974dB8wtLbJTWLiHVarHnOjpp/so1I/X9tqsJDKEar8VgphTdfWtBiJnB+A+BHt+f09GCgPBrle0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_flow.png
// module id = B4Ce
// module chunks = 1